'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge } from '@uzh-bf/design-system';
import { useTranslations } from 'next-intl';
import { twMerge } from 'tailwind-merge';
type BlockTagType = 'optional' | 'notRelevantExam';
const TAG_STYLES: Record<BlockTagType, string> = {
  optional: 'border-gray-300 bg-gray-50 text-gray-600',
  notRelevantExam: 'border-amber-300 bg-amber-50 text-amber-800'
};
function BlockTag(t0) {
  const $ = _c(9);
  const {
    tag,
    className
  } = t0;
  const t = useTranslations();
  if (!tag) {
    return null;
  }
  const t1 = TAG_STYLES[tag];
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = twMerge("h-5 rounded-md px-1.5 py-0 text-[11px] leading-4 font-medium shadow-none", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `block.tag${tag}`;
  let t4;
  if ($[3] !== t || $[4] !== t3) {
    t4 = t(t3);
    $[3] = t;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <Badge variant="outline" className={t2}>{t4}</Badge>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
export default BlockTag;